export type RanchCentroid = {
  latitude: number | null;
  longitude: number | null;
} | null | undefined;

export type CentroidCoords = { lat: number; lng: number };

export function getCentroidFromRanch(centroid: RanchCentroid): {
  coords: CentroidCoords;
  isValid: boolean;
} {
  const lat = centroid != null ? centroid.latitude : null;
  const lng = centroid != null ? centroid.longitude : null;

  const isValid =
    typeof lat === 'number' &&
    typeof lng === 'number' &&
    Number.isFinite(lat) &&
    Number.isFinite(lng);

  if (!isValid) {
    return { coords: { lat: 0, lng: 0 }, isValid: false };
  }

  return { coords: { lat: lat as number, lng: lng as number }, isValid: true };
}
